<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h1 mat-dialog-title>Acción realizada :: <strong>Modificar</strong></h1>
  <mat-divider></mat-divider>
  <br>
  <div mat-dialog-content cdkTrapFocus>
      <app-actualizar-tipo-movimiento></app-actualizar-tipo-movimiento>
  </div>
